export function getDefaultState() {
    return {
        assets: {},
        facilities: null,
        selectedAsset: null,
        selectedFacility: null,
        // key: asset id, value: stream data properties (i.e. 'status', 'product', ...)
        statuses: {},
        // key: asset id, value: quality event details per asset
        qualityEvents: {},
        // key: asset id, value: list of sensors
        sensors: {},
        assetGroups: {},
        facilityGroups: {},
        // facility ids with load assets request that has failed, this is recorded so that the navigation
        // guard can handle route parameters accordingly based on whether an attempt to load assets for a
        // particular facility has been made before.
        failedAssetLoads: {},
        // initializing the state that will store the filtered selected groups for a particular facility. This is being done so
        // that when a user selects groups on facility dashboard page and navigates back and forth to asset dashboards, the selected
        // filtered groups remains unchanged.
        // key: facility_id, value: list of selected groups for that facility.
        storedAssetGroupsPerFacility: {},
        disconnectedAssets: new Set(),
        assetsWithSensors: new Set(),
        defects: {}
    };
}

export default {
    ...getDefaultState()
};
